import { createRouter, createWebHistory } from "vue-router";

import store from "./store";

import AdminLayout from "alzata.ui.vue/layouts/AlzataAdminLayout.vue";
import ModalLayout from "alzata.ui.vue/layouts/AlzataModalLayout.vue";

import NotFound from "@/pages/NotFound.vue";

// import AlzataRouteList from "alzata.ui.vue/pages/AlzataRouteList.vue";
import AlzataUserList from "alzata.ui.vue/pages/AlzataUserList.vue";
import AlzataRoleList from "alzata.ui.vue/pages/AlzataRoleList.vue";

import AlzataSignIn from "alzata.ui.vue/pages/account/AlzataSignIn.vue";
import AlzataCreateAccount from "alzata.ui.vue/pages/account/AlzataCreateAccount.vue";
import AlzataRecoverAccount from "alzata.ui.vue/pages/account/AlzataRecoverAccount.vue";
import AlzataResetPassword from "alzata.ui.vue/pages/account/AlzataResetPassword.vue";
import AlzataConfirmAccount from "alzata.ui.vue/pages/account/AlzataConfirmAccount.vue";
import AlzataConfirmInviteAccount from "alzata.ui.vue/pages/account/AlzataConfirmInviteAccount.vue";
import AlzataProfile from "alzata.ui.vue/pages/account/AlzataProfile.vue";

import DogList from "@/pages/DogList.vue";
import VeteranList from "@/pages/VeteranList.vue";
import VeterinaryList from "@/pages/VeterinarianList.vue";
import TaskItemsList from "@/pages/TaskItemsList.vue";
import AdminList from "@/pages/AdminList.vue";

const pageMap = {
  AlzataUserList,
  AlzataRoleList,
  AdminList,
  VeteranList,
  DogList,
  VeterinaryList,
  TaskItemsList,
};

function mapRoutes(routeInfo) {
  const routes = routeInfo
    .filter((x) => x.sidebarOrder != null)
    .map((x) => {
      return {
        name: x.routeName,
        path: x.path,
        component: pageMap[x.component] || NotFound,
        children: [],
        meta: { requiresAuth: true },
        props: true,
      };
    });

  routes.push({
    name: "error",
    path: ":pathMatch(.*)*",
    component: NotFound,
  });

  return {
    name: "adminRoot",
    path: "/",
    component: AdminLayout,
    children: routes,
  };
}

export const routes = [
  {
    path: "/account",
    component: ModalLayout,
    children: [
      {
        name: "alzata:account/login",
        path: "login",
        component: AlzataSignIn,
      },
      {
        name: "alzata:account/create",
        path: "sign-up",
        component: AlzataCreateAccount,
      },
      {
        name: "alzata:account/confirm",
        path: "confirm",
        component: AlzataConfirmAccount,
      },
      {
        name: "alzata:account/recover",
        path: "forgot-password",
        component: AlzataRecoverAccount,
      },
      {
        name: "alzata:account/resetpassword",
        path: "resetpassword",
        component: AlzataResetPassword,
      },
      {
        name: "alzata:account/confirminvite",
        path: "confirm-invite",
        component: AlzataConfirmInviteAccount,
      },
      {
        name: "alzata:account/profile",
        path: "profile",
        component: AlzataProfile,
        meta: { requiresAuth: true },
      },
    ],
  },
  mapRoutes([]),
];

const router = createRouter({
  history: createWebHistory("/"),
  routes,
});

router.pageMap = pageMap;

router.beforeEach((to) => {
  const alzataAuth = localStorage.getItem("alzata-auth");
  if (to.meta.requiresAuth && alzataAuth === null) {
    return {
      path: "/account/login",
      name: "alzata:account/login",
      query: { redirect: to.fullPath },
    };
  }
});

store.subscribe((mutation) => {
  if (mutation.type === "iam/setRoutes") {
    // Remap the routes
    if (mutation.payload.length === 0) {
      if (
        router.currentRoute.value.name !== "alzata:account/resetpassword" &&
        router.currentRoute.value.name !== "alzata:account/confirm" &&
        router.currentRoute.value.name !== "alzata:account/confirminvite"
      ) {
        router.replace({ name: "alzata:account/login" });
      }
    } else {
      const routes = mapRoutes(mutation.payload);
      const cur = router.currentRoute.value;
      router.removeRoute("adminRoot");
      router.addRoute(routes);
      router.replace(cur.fullPath);
    }
  }
  if (mutation.type === "iam/signOut") {
    router.replace({ name: "alzata:account/login" });
  }
});

export default router;
